<template>
	<el-row>
		<!--        form-->
		<el-row>
			<el-form :model="addForm" label-position="left" label-width="120px">
				<el-row>
					<el-col :span="8">
						<el-form-item label="计划名称:">
							<el-input size="mini" placeholder="请输入内容" v-model="addForm.planTitle">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="计划主题:">

							<el-select @change="SwitchPlan" placeholder="请选择" clearable size="mini"
								v-model="addForm.titleType">
								<el-option v-for="item in planLists" :key="item.id" :label="item.dicType"
									:value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="计划日期:">
							<el-date-picker size="mini" v-model="addForm.startTime" type="datetime"
								format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
							</el-date-picker>
							<div style="text-align: center; width: 220px; line-height: normal">
								-
							</div>
							<el-date-picker size="mini" v-model="addForm.endTime" type="datetime"
								format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

			</el-form>
		</el-row>
		<!--        table-->
		<el-row>
			<div v-if="addForm.titleType == 4">
				<el-row>
					<el-col :span="1">序号</el-col>
					<el-col :span="23">关联活动内容</el-col>
				</el-row>
				<el-row>
					<el-col :span="1">01</el-col>
					<el-col :span="23">
						<div>
							<el-select v-model="addForm.infoList[0].activityId" @change="materSelect($event)"
								placeholder="请选择">
								<el-option v-for="matItem in materials" :key="matItem.id" :label="matItem.activityName"
									:value="matItem.id">
								</el-option>
							</el-select>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="1">02</el-col>
					<el-col :span="23">
						<div>
							<el-button type="success" plain @click="addCommldity2()">关联活动商品</el-button>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="1"></el-col>
					<el-col :span="23">
						<el-table :data="addForm.infoList[1].goods" style="width: 100%">
							<el-table-column prop="productId" label="商品ID" width="180">
							</el-table-column>
							<el-table-column prop="productName" label="商品名称" width="180">
							</el-table-column>
							<el-table-column prop="productStartTime" label="上架时间" width="180">
							</el-table-column>
							<el-table-column prop="productEndTime" label="下架时间" width="180">
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button size="mini" type="danger"
										@click="handleDeleteGoods(scope.$index, scope.row)">删除
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</div>
			<div v-else>
				<el-table :data="addForm.infoList" style="width: 100%">
					<el-table-column type="index" width="70" label="序号"></el-table-column>
					<el-table-column prop="infoName" label="字段名称" width="180">
					</el-table-column>
					<el-table-column prop="dicType" label="类型" width="180">
					</el-table-column>
					<el-table-column prop="address" label="内容关联">
						<template slot-scope="scope">
							<!--                        课程-->
							<div v-if="scope.row.infoType == 8">
								<el-button type="success" plain @click="addCourse(scope.$index)">选择课程</el-button>
							</div>
							<div v-else-if="scope.row.infoType == 9">
								<el-button type="success" plain @click="addCommldity(scope.$index)">添加商品</el-button>
							</div>
							<div v-else-if="scope.row.infoType == 10" @click="textareawrite(scope.$index)">
								<el-row>
									<el-input type="planInfo" placeholder="请输入内容"
										v-model="addForm.infoList[scope.$index].planInfo" maxlength="500"
										show-word-limit>
									</el-input>
								</el-row>
								<el-row>
									<!--                                图-->
									<el-row>
										<span>注：最多传10张</span>
									</el-row>
									<el-row>
										<div style="display: inline-block;"
											v-for="(item,i) in addForm.infoList[scope.$index].planPics">
											<img v-if="item" :src="item" class="avatar">
										</div>
										<el-upload class="avatar-uploader" :action="requestUrl" :show-file-list="false"
											:on-success="handleAvatarSuccess" :on-error="uploadError"
											:before-upload="beforeAvatarUpload">
											<img v-if="imageUrl" :src="imageUrl" class="avatar">
											<i v-else class="el-icon-plus avatar-uploader-icon"></i>
										</el-upload>
									</el-row>
								</el-row>
							</div>
							<div v-else-if="scope.row.infoType == 13">
								<el-button type="success" plain @click="addsqyx('shequn')">选择社群讲解</el-button>
							</div>
							<div v-else>
								<el-button type="success" plain @click="addsqyx()">选择营销讲解</el-button>
							</div>
						</template>
					</el-table-column>

					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<!--        添加字段-->
				<el-row>
					<el-button type="primary" @click="addField">添加字段</el-button>
				</el-row>
			</div>
		</el-row>
		<el-row>
			<el-button style="margin-top: 20px;" type="primary" @click="release">{{inOrUpType == 1 ? '发布' : '修改'}}计划
			</el-button>
		</el-row>

		<!--        选择课程-->
		<el-row>
			<el-col :span="24">
				<el-drawer title="查询课程" :visible.sync="table3" :append-to-body=true direction="rtl" size="50%"
					style="overflow: auto">
					<div>
						<div style="overflow: auto">
							<div class="block">
								<span class="demonstration">选择课程</span>
								<el-cascader v-model="tyzs" placeholder="搜索课程/下拉选择" :options="kcoptions"
									:props="{ multiple: true }" filterable @change="kcchange('kc')">
								</el-cascader>
							</div>
						</div>
					</div>

				</el-drawer>
			</el-col>

		</el-row>
		<el-row>
			<el-col :span="24">
				<el-drawer title="请选择社群讲解" :visible.sync="table4" :append-to-body=true direction="rtl" size="50%"
					style="overflow: auto">
					<div>
						<div style="overflow: auto">
							<div class="block">
								<span class="demonstration">请选择社群讲解</span>
								<el-cascader v-model="shequn" placeholder="搜索/下拉选择" :options="sqoptions"
									:props="{ multiple: true }" filterable @change="kcchange('sq')">
								</el-cascader>
							</div>
						</div>
					</div>

				</el-drawer>
			</el-col>

		</el-row>
		<el-row>
			<el-col :span="24">
				<el-drawer title="请选择营销讲解" :visible.sync="table5" :append-to-body=true direction="rtl" size="50%"
					style="overflow: auto">
					<div>
						<div style="overflow: auto">
							<div class="block">
								<span class="demonstration">请选择营销讲解</span>
								<el-cascader v-model="yingxiao" placeholder="搜索/下拉选择" :options="yxoptions"
									:props="{ multiple: true }" filterable @change="kcchange('yx')">
								</el-cascader>
							</div>
						</div>
					</div>

				</el-drawer>
			</el-col>

		</el-row>

		<!--       存放弹窗-->
		<el-row>
			<SalesPlanPopUps :addFieldShow="addFieldShow" :customData="customData"
				v-on:addFieldClose="addFieldClose($event)" v-on:sendData="sendData($event)"></SalesPlanPopUps>
			<SelectCommodityPopUp :comShow="comShow" :addList="commodGoods" v-on:comClose="comClose($event)"
				v-on:sendMes="sendMes($event)"></SelectCommodityPopUp>
		</el-row>
	</el-row>
</template>

<script>
	import SalesPlanPopUps from '../../../components/popUps/SalesPlanPopUps.vue'
	import SelectCommodityPopUp from '../../../components/popUps/SelectCommodityPopUps.vue'
	import httpClient from '../../../util/request.js';
	export default {

		components: {
			SalesPlanPopUps,
			SelectCommodityPopUp
		},
		watch: {},
		data() {
			return {
				table4: false,
				table5: false,
				kcoptions: [],
				tyzs: [],
				sqoptions: [],
				shequn: [],
				yxoptions: [],
				yingxiao: [],
				inOrUpType: 1,
				commodGoods: [],
				materials: [],
				table3: false,
				pageSize3: 30,
				pageNum3: 0,
				requestUrl: httpClient.imgUrl,
				imageUrl: '', // 图文-图
				content: '', // 富文本内容
				editorOption: {
					placeholder: '编辑文章内容'
				},
				fieldData: null,
				addFieldShow: false, // add Field is show or hide
				addForm: {
					planId: '',
					planTitle: '',
					startTime: '',
					endTime: '',
					titleType: null,
					activity: {},
					chapters: [],
					goods: [],
					communitys: [],
					texts: [],
					explains: [],
					infoList: []
				},
				typeList: [],
				planLists: [], //计划主题列表
				customData: [], //自定义字段列表数据
				pageNum: 0,
				pageSize: 20,
				total: 0,
				comShow: false, // 添加商品弹出框
				classData: [], // 课程列表
				total3: 0,
				selectClassData: null,
				temporaryIndex: 0,
				temporaryGoodsIndex: 0,
				textareaIndex: 0,
				weekPlanId: null,

			}
		},
		mounted() {
			// 每日爆品
			this.selectPlan(1);
			this.selectPlanType(2);
			this.query();
			this.getClass();
			this.getActivity();
			if (this.$route.query.queryType == 1) {
				this.inOrUpType = 1;
				// add
			} else if (this.$route.query.queryType == 2) {
				this.inOrUpType = 2;
				// update
				this.addForm = JSON.parse(this.$route.query.queryData)
				console.log(this.addForm, "第一步，获取点击编辑得到的数据this.addForm")
				this.selectList(this.addForm.planId, this.addForm.titleType, this.addForm.infoTypes)
			}
		},
		methods: {
			kcchange(e) {
				if (e == 'kc') {
					console.log(this.tyzs)
					this.addForm.chapters = [];
					this.tyzs.forEach(item => {
						this.addForm.chapters.push({
							courseId: item[0],
							courseName: "",
							chapterId: item[1].id,
							chapterTitle: item[1].title
						})
					})


				} else if (e == 'sq') {
					console.log(this.shequn)
					this.addForm.communitys = [];
					this.shequn.forEach(item => {
						this.addForm.communitys.push({
							communityId: item[0].id,
							communityTitle: item[0].title,

						})
					})
				} else {
					console.log(this.yingxiao, "yingxiao")
					this.addForm.explains = [];
					this.yingxiao.forEach(item => {
						this.addForm.explains.push({
							explainId: item[0].id,
							explainName: item[0].title,

						})
					})
				}
			},
			addsqyx(e) {
				if (e == 'shequn') {
					console.log("点击了社群")

					this.$http.get('/api/source/clrWeekPlan/selectCommunity', {
						deleteStatus: 0,
						kcFlag: ""
					}).then(res => {
						if (res.data.status == 0) {
							this.table4 = true
							console.log(res.data.data)
							res.data.data.forEach(item => {
								this.sqoptions.push({
									value: {
										id: item.id,
										title: item.title
									},
									label: item.title
								})
							})
						} else {
							this.$message({
								type: 'error',
								message: '获取社群讲解列表失败！'
							});
						}
					});
				} else {
					console.log("点击了营销")
					this.$http.post('/api/source/clrExplain/select', {
						deleteStatus: 0,
						kcFlag: ""
					}).then(res => {
						if (res.data.status == 0) {
							this.table5 = true
							console.log(res.data.data)
							res.data.data.forEach(item => {
								this.yxoptions.push({
									value: {
										id: item.id,
										title: item.name
									},
									label: item.name
								})
							})
						} else {
							this.$message({
								type: 'error',
								message: '获取营销讲解列表失败！'
							});
						}
					});
				}

			},
			materSelect(result) {
				for (let i = 0; i < this.materials.length; i++) {
					if (this.materials[i].id == result) {
						this.addForm.infoList[0].activityName = this.materials[i].activityName
						break;
					}
				}
			},
			selectList(num, type, infoTypes) {
				var that = this
				this.$http.post('/api/source/clrWeekPlan/selectPlanInfo', {
					planId: num,
					titleType: type,
					infoTypes: infoTypes,
				}).then(res => {
					if (res.data.data.activity == null) {
						this.addForm.activity = {}
					} else {
						this.addForm.activity = res.data.data.activity;
					}


					this.addForm.chapters = res.data.data.chapters;
					this.addForm.communitys = res.data.data.communitys;
					this.addForm.explains = res.data.data.explains;
					this.addForm.goods = res.data.data.goods;
					this.addForm.texts = res.data.data.texts;
					this.addForm.infoList = []
					console.log(this.addForm, "第二步，在这里将新数据转成旧版数据添加到this.addForm.infoList展示")
					var bb = [];
					infoTypes.split(",").forEach(item => {
						this.customData.forEach(item2 => {
							if (item2.dicTypeId == item) {
								if (item == 10) {
									for (var i = 0; i < that.addForm.texts.length; i++) {
										bb.push(item2)
										// addForm.infoList.planInfo=this.addForm.texts[i].planInfo
									}

								} else {
									bb.push(item2)
								}

							}
						})
					})
					bb.forEach(item => {
						this.addForm.infoList.push({
							activityId: "",
							courseId: "",
							dicType: item.dicType,
							goods: [],
							infoName: item.dicValue,
							infoType: item.dicTypeId,
							planInfo: "",
							planPics: []
						})

					})
					var i = 0;
					this.addForm.infoList.forEach((item, index) => {

						if (item.infoType == 10) {

							item.planInfo = this.addForm.texts[i].planInfo;
							item.planPics = this.addForm.texts[i].planPics;
							i++;
						}


					})

					this.addFieldShow = true;
					this.addFieldShow = false;
					this.addForm.chapters.forEach(item => {
						this.tyzs.push(
							[item.courseId, {
								id: item.chapterId,
								title: item.chapterTitle
							}]
						)
						this.weekPlanId = item.weekPlanId
					})
					this.addForm.communitys.forEach(item => {
						this.shequn.push(
							[{
								id: item.communityId,
								title: item.communityTitle
							}]
						)
					})
					this.addForm.explains.forEach(item => {
						this.yingxiao.push(
							[{
								id: item.explainId,
								title: item.explainName
							}]
						)
					})

				});
			},
			getActivity() {
				this.$http.post('/api/source/matMarkActivity/listPage?pageNum=0&pageSize=100', {
					status: 0
				}).then(res => {
					this.materials = res.data.data.list;
				});

			},
			handleDeleteGoods(index, result) {
				this.addForm.infoList[1].goods.splice(index, 1);
				if (this.addForm.infoList[0].goods != null) {
					this.addForm.infoList[0].goods = [];
				}
			},
			SwitchPlan(result) {
				if (result == 4) {
					// 营销活动
					let newData = {
						info_type: '', // 内容类型
						activityId: '', // 素材id
						infoName: '',
						infoType: '',
						dicType: 0,
						courseId: '',
						goods: [],
						planInfo: '',
						planPics: [],
					}
					let newData2 = {
						info_type: '', // 内容类型
						activityId: '', // 素材id
						infoName: '',
						infoType: '',
						dicType: 0,
						courseId: '',
						goods: [],
						planInfo: '',
						planPics: [],
					}
					this.addForm.infoList.push(newData); // 素材
					this.addForm.infoList.push(newData2); // 商品
				} else {
					this.addForm.infoList = [];
				}
			},
			release() {
				if (this.addForm.startTime == '' || this.addForm.endTime == '') {
					this.$message({
						type: 'error',
						message: '请输入时间~~'
					});
					return false;
				}
				if (this.addForm.titleType == null || this.addForm.titleType == '') {
					this.$message({
						type: 'error',
						message: '请选择计划主题~~'
					});
					return false;
				}
				const that = this;
				console.log(that.addForm.infoList, "that.addForm.infoList")
				that.addForm.infoList.forEach(item => {
					if (item.planInfo.trim() != "" || item.planPics.length > 0) {
						that.addForm.texts.push({
							planInfo: item.planInfo,
							planPics: item.planPics
						})
					}
					if (item.goods.length > 0) {
						that.addForm.goods = item.goods
					}
					if (item.activityId != "") {
						that.addForm.activity.activityId = item.activityId;
						that.addForm.activity.activityName = item.activityName;
						that.addForm.goods = item.goods
					}
				})
				console.log(that.addForm, "第三步，查看编辑之后的数据this.addForm")
				return false
				var url = '/api/source/clrWeekPlan/insert';
				if (that.inOrUpType == 2) {
					url = '/api/source/clrWeekPlan/update';
					that.addForm.chapters.forEach(item => {
						item.weekPlanId = this.weekPlanId
					})
				}
				this.$http.post(url, that.addForm).then(res => {
					if (res.data.data.status == 0) {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.$router.push({
							path: '/planlist'
						})
					} else {
						this.$message({
							type: 'error',
							message: '系统繁忙，请稍后再试~~'
						});
					}
				});

			},
			textareawrite(index) {
				this.textareaIndex = index;
			},
			clickProductIs3(result) {
				// 课程id
				this.addForm.infoList[this.temporaryIndex].courseId = result.courseId;
				this.addForm.infoList[this.temporaryIndex].courseName = result.courseName
				this.table3 = false;

			},
			getClass() {
				this.$http.get('/api/source/clrWeekPlan/selectCourseAndChapter', {}).then(res => {
					this.classData = res.data.data;
					var c = [];
					this.classData.forEach(item => {
						item.chapterList.forEach(item2 => {
							c.push({
								value: {
									id: item2.chapterId,
									title: item2.chapterTitle
								},
								label: item2.chapterTitle
							})
						})
						this.kcoptions.push({
							value: item.courseId,
							label: item.courseName,
							children: c
						})
						c = [];
					})
				});
			},
			//pagesize改变
			handleSizeChange3(val) {
				this.pageSize3 = 1;
				this.pageSize3 = val;
				this.getClass();
			},

			//页码改变
			handleCurrentChange3(val) {
				this.pageNum3 = val;
				this.getClass();
			},
			addCourse(index) {
				this.temporaryIndex = index;
				this.table3 = true;
			},
			sendMes(result) {
				this.addForm.infoList[this.temporaryGoodsIndex].goods = [];
				result.forEach((item, index) => {
					this.addForm.infoList[this.temporaryGoodsIndex].goods.push(item);
				})

			},
			comClose(result) {
				this.comShow = result;
			},
			// 添加商品
			addCommldity(index) {

				this.commodGoods = [];
				this.temporaryGoodsIndex = index;
				this.comShow = true;
				this.addForm.infoList[index].goods.forEach((item, index) => {
					this.commodGoods.push(item)
				})
				this.addForm.goods.forEach(item => {
					this.commodGoods.push({
						productEndTime: item.productEndTime,
						productId: item.productId,
						productName: item.productName,
						productPic: item.productPic,
						productPrice: item.productPrice,
						productStartTime: item.productStartTime
					})
				})
				console.log(this.commodGoods, "this.commodGoods")
			},
			addCommldity2() {
				this.temporaryGoodsIndex = 1;
				this.comShow = true;

			},
			uploadError(err, file, fileList) {
				alert(err);
			},
			// 图文--图
			handleAvatarSuccess(res, file) {
				this.addForm.infoList[this.textareaIndex].planPics.push(res.data)
				console.log(this.addForm, "ceshi10086")
			},
			beforeAvatarUpload(file) {
				const isLength = this.addForm.infoList[this.textareaIndex].planPics.length >= 10 ? false : true;
				if (!isLength) {
					this.$message.error('上传图片不能超过10张');
				}
				return isLength;
			},
			// 富文本
			onEditorChange({
				editor,
				html,
				text
			}) {
				this.content = html;
			},
			//选中的数据
			sendData(result) {
				if (result != null) {
					let showData = {
						activityId: '', // 素材id
						infoName: result.dicValue, //更新的
						infoType: result.dicTypeId,
						dicType: result.dicType, // 富文本
						courseId: '',
						goods: [],
						planInfo: '',
						planPics: [],
					}
					this.addForm.infoList.push(showData)

				}
			},
			// 弹窗关闭
			addFieldClose(result) {
				this.addFieldShow = false;
			},
			// add Field button
			addField() {
				this.addFieldShow = true;
			},
			// table delete
			handleDelete(x, y) {
				this.addForm.infoList.splice(x, 1);
			},
			// 查询自定义字段列表数据
			query() {
				this.$http.post('/api/source/clrWeekPlan/selectDic?pageNum=' + this.pageNum + '&pageSize=' + this
					.pageSize, {
						status: 0
					}).then(res => {
					this.customData = res.data.data.list;
					this.total = res.data.data.total;
				});
			},
			queryForType() {

			},
			// 查询主题
			selectPlan(num) {
				this.$http
					.get(
						`/api/source/clrWeekPlan/selectDicType?parentId=${num}`
					)
					.then((res) => {
						if (res.data.status == 0) {
							let list = res.data.data;
							this.planLists = list;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			// 查询主题
			selectPlanType(num) {
				this.$http
					.get(
						`/api/source/clrWeekPlan/selectDicType?parentId=${num}`
					)
					.then((res) => {
						if (res.data.status == 0) {
							let list = res.data.data;
							this.typeList = list;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 48px;
		height: 48px;
		line-height: 48px;
		text-align: center;
	}

	.avatar {
		width: 48px;
		height: 48px;
		margin-left: 5px;
		/*display: block;*/
	}
</style>
